import React from "react";
import PracticsQuestionTopics from "../../../topics/PracticsQuestionTopics";


function ChapterWisePYQBioTopics() {
  return (
    <>


      <PracticsQuestionTopics subject="biology" type="chapterwisepyq" />

    </>
  );
}

export default ChapterWisePYQBioTopics;